<template>
  <div class="historycate-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">添加分类</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      title="添加分类"
      @on-ok="createAttr('attrValidate')"
      :loading="loading"
    >
      <Form :model="attr" ref="attrValidate" :rules="attrValidate" action="javascript:void(0)">
        <FormItem label="分类名称" prop="title">
          <Input v-model="attr.title" placeholder="输入分类名称..."></Input>
        </FormItem>
        <FormItem label="排序">
          <Input v-model="attr.sort" placeholder="输入排序..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal
      v-model="showEditInfoStatus"
      title="修改分类"
      @on-ok="updateAttr('attrValidate')"
      :loading="loading"
    >
      <Form :model="attr" ref="attrValidate" :rules="attrValidate" action="javascript:void(0)">
        <FormItem label="分类名称" prop="title">
          <Input v-model="attr.title" placeholder="输入分类名称..."></Input>
        </FormItem>
        <FormItem label="排序">
          <Input v-model="attr.sort" placeholder="输入排序..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "historycate-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      formItem: {},
      pages: {
        current: 1,
        size: 10
      },
      columns1: [
        {
          title: "排序",
          key: "sort",
          width: 100,
          fixed: "left"
        },
        {
          title: "Id",
          key: "id",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "分类名称",
          key: "title",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      attr: {
        sort: "0"
      },
      showModalStatus: false,
      showEditInfoStatus: false,
      attrValidate: {
        title: [
          { required: true, message: "分类名称必须填写", trigger: "blur" }
        ]
      }
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.historycate.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel() {
      this.attr = {
        sort: "0"
      };
      this.$refs["attrValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createAttr(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.historycate
            .create({
              title: this.attr.title,
              sort: this.attr.sort
            })
            .then(res => {
              if (res.code == 200) {
                this.showModalStatus = !this.showModalStatus;
                this.attr.title = "";
                this.getTableList();
              }
            });
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //展开修改
    showEditInfo: function(index) {
      this.attr = {};
      this.attrid = index;
      this.$refs["attrValidate"].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.historycate.detail({ category_id: index }).then(res => {
        if (res.code == 200) {
          this.attr = res.result;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 修改名称
    updateAttr: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.historycate
            .edit({
              category_id: this.attrid,
              title: this.attr.title,
              sort: this.attr.sort
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showEditInfoStatus = !this.showEditInfoStatus;
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showCreateStatus = !this.showCreateStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.historycate.remove({ category_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
